import { EventCategories, EventActions, EventLabels } from '../constants/Analytics';

export default function decorateHistoryWithAnalytics(history) {
  history.listen(location => {
    setTimeout(
      () =>
        window.dataLayer.push({
          event: 'sendPageview',
          pagePath: location.pathname,
          pageTitle: document.title
        }),
      2000
    );
  });
  return history;
}

export const registerPinterestTracking = () => {
  window.addEventListener('click', event => {
    const element = event.target || event.srcElement;

    if (!element.getAttribute('data-pin-log')) {
      return;
    }

    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'hipagesInteractiveEvent',
      eventCategory: EventCategories.ARTICLES,
      eventAction: EventActions.PINTEREST_CLICK_SAVE_BUTTON,
      eventLabel: EventLabels.PINTEREST_CLICK_SAVE_BUTTON
    });
  });
};

export const trackEvent = (
  eventCategory = '',
  eventAction = '',
  eventLabel = '',
  eventProperty = '',
  eventValue = '',
  interactive = true,
  eventContexts = []
) => {
  if (typeof window === 'undefined') return false;
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: interactive ? 'hipagesInteractiveEvent' : 'hipagesNonInteractiveEvent',
    eventCategory,
    eventAction,
    eventLabel,
    eventProperty,
    eventValue,
    eventContexts: eventContexts.concat(window.pageContexts)
  });
};
